import React from 'react'
import styled from 'styled-components'
import { Field } from 'react-final-form'

import { WEEKDAYS } from '../../../constants/time';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Label = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold};
`

const Restriction = styled.div`
    display: flex;
    flex-direction: row;
`

const Day = styled.span`
    font-size: 14px;
    color: ${props => props.theme.colors.textPrimary};
    width: 60px;
`

const Time = styled.span`
    font-size: 14px;
    color: ${props => props.theme.colors.mediumGrey};
`

export const RestrictionList = ({field, restrictions}) => {

    if (!restrictions || restrictions.length === 0) return null;

    const getWeekdayName = (day) => {
        if (day < WEEKDAYS.length) {
            return WEEKDAYS[day].name
        }
        return day
    }

    return (
        <Wrapper>
            <Label>
                Horários Disponíveis
            </Label>
            {restrictions.map( (restriction,i) => (
                <Field name={`${field}[${i}]`}>
                    {
                        (fieldProps) => (
                            <Restriction>
                                <Day>{getWeekdayName(restriction.day)}</Day>
                                <Time>{restriction.fromTime} às {restriction.toTime}</Time>
                            </Restriction>
                        )
                    }
                </Field>
            ))}
        </Wrapper>
    )
}